import React from "react";

export const ContactPage = () => {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Contact</h1>
      </header>
    </div>
  );
};
